// SH9: the company switcher lists each business that runs reachable sites. The server sends, per account, its reachable
// sites grouped by the business that runs them (`groups`) and whether every site of the account is reachable
// (`allSites`). An account with several groups gets one "<account> - all sites" entry (All Locations = the whole
// account, as before) plus one entry per group; choosing a group only filters the location dropdown. Access is still
// decided by the server on every request.
const KEY = 'companySelectedSiteGroup';
const validId = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,200}$/.test(value);

export function buildCompanyEntries(organizations = []) {
  const entries = [];
  const emptyHomes = [];
  for (const org of organizations) {
    const groups = Array.isArray(org.groups) ? org.groups : [];
    const base = { orgId: org.id, direct: org.direct === true, entitlement: org.entitlement, type: org.type };
    if (org.direct && groups.length === 0 && Array.isArray(org.groups)) {
      // A company home with no sites of its own: its own account settings (users, billing).
      emptyHomes.push({ ...base, key: org.id, name: `${org.name} - account`, groupKey: null, locationIds: null });
    } else if (groups.length <= 1) {
      entries.push({ ...base, key: org.id, name: groups[0]?.name || org.name, groupKey: null, locationIds: null });
    } else {
      if (org.allSites) entries.push({ ...base, key: org.id, name: `${org.name} - all sites`, groupKey: null, locationIds: null });
      for (const group of groups) {
        entries.push({ ...base, key: `${org.id}::${group.key}`, name: group.name, groupKey: group.key,
          locationIds: group.locationIds });
      }
    }
  }
  return [...entries, ...emptyHomes];
}

export function readSiteGroup(uid) {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!value || value.uid !== uid || !validId(value.orgId) || !validId(value.groupKey) ||
        !Array.isArray(value.locationIds) || !value.locationIds.every(validId)) return null;
    return value;
  } catch {
    return null;
  }
}

export function writeSiteGroup(uid, entry) {
  if (entry?.groupKey) {
    sessionStorage.setItem(KEY, JSON.stringify({ uid, orgId: entry.orgId, groupKey: entry.groupKey, locationIds: entry.locationIds }));
  } else {
    sessionStorage.removeItem(KEY);
  }
}

export function clearSiteGroup() { sessionStorage.removeItem(KEY); }
